<div class="flex-1 container mx-auto px-4 py-12">

    <!-- HEADER -->
    <div class="max-w-4xl mx-auto mb-16 text-center">
        <h1 class="text-4xl md:text-5xl font-display font-bold mb-6">
            My Projects
        </h1>

        <p class="text-xl text-muted-foreground mb-8">
            A collection of AI experiments, open-source tools, and full-stack applications.
        </p>

        <!-- SEARCH -->
        <div class="relative max-w-lg mx-auto">
            <!-- Search icon -->
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>

            <input type="text" [(ngModel)]="search" placeholder="Search projects by name, tech, or description..." class="w-full pl-12 py-6 rounded-xl bg-secondary/30 border border-border
                 focus:border-primary/50 text-lg outline-none" />
        </div>
    </div>

    <!-- LOADING -->
    <ng-container *ngIf="isLoading(); else projectsLoaded">
        <div class="flex justify-center py-20">
            <!-- Loader -->
            <svg class="w-10 h-10 animate-spin text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" opacity="0.25" />
                <path d="M22 12a10 10 0 0 1-10 10" />
            </svg>
        </div>
    </ng-container>

    <!-- PROJECT LIST -->
    <ng-template #projectsLoaded>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

            @for(proj of filteredProjects(); track $index) {
            <app-project-card [project]="proj" />
            }

            <!-- EMPTY STATE -->
            <div *ngIf="filteredProjects().length === 0" class="col-span-full text-center py-20">
                <p class="text-muted-foreground text-lg">
                    No projects found matching your search.
                </p>
            </div>
        </div>
    </ng-template>
</div>